import request from "@/utils/httpRequest.js"

/**
 */
 export function fetchTestingRecord(params) {
  return request({
    url: 'testing/record',
    method: 'get',
    params
  })
}

export function fetchRecord(data) {
  return request({
    url: 'testing/record/fetch',
    method: 'post',
    data
  })
}

export function savePO(data) {
  return request({
    url: 'testing/record/po',
    method: 'post',
    data
  })
}

export function submit(params) {
  return request({
    url: 'testing/record/submit',
    method: 'post',
    params
  })
}

export function pay(params) {
  return request({
    url: 'testing/record/pay',
    method: 'post',
    params
  })
}

export function cardPay(params) {
  return request({
    url: 'testing/record/card-pay',
    method: 'post',
    params
  })
}

export function h5Pay(params) {
  return request({
    url: 'testing/record/h5-pay',
    method: 'post',
    params
  })
}

export function h5Buy(params) {
  return request({
    url: 'testing/record/h5-buy',
    method: 'post',
    params
  })
}

export function h5Free(params) {
  return request({
    url: 'testing/record/h5-free',
    method: 'post',
    params
  })
}

export function h5PayResult(params) {
  return request({
    url: 'testing/record/h5-pay-result',
    method: 'get',
    params
  })
}

export function auth(params) {
  return request({
    url: 'testing/record/auth',
    method: 'get',
    params
  })
}

export function freeAuth(params) {
  return request({
    url: 'testing/record/free-auth',
    method: 'get',
    params
  })
}

export function continuePay(params) {
  return request({
    url: 'testing/record/continue-pay',
    method: 'post',
    params
  })
}

export function fetchIngRecord() {
  return request({
    url: 'testing/record/ing',
    method: 'get'
  })
}

export function recentRecord() {
  return request({
    url: 'testing/record/recent',
    method: 'get'
  })
}
